import React from 'react';
import ToolTip from 'react-portal-tooltip';
import * as d3 from 'd3';
import PropTypes from 'prop-types';

const tooltipStyle = {
  style: {
    background: 'rgba(64,64,64,.8)',
    color: '#fff',
    padding: 20,
    boxShadow: '5px 5px 3px rgba(0,0,0,.5)',
  },
  arrowStyle: {
    color: 'rgba(128,128,128,.8)',
    borderColor: false,
  },
};

export default function MapTooltip({
  classes,
  currentData,
  currentFilter,
  currentMode,
  data,
  dayProduction,
  geography,
  hasForecast,
  installedCapacity,
  isActive,
  isPlaying,
  lang,
  municipalityId,
  productionLastHour,
  uncutDayProduction,
  unitHour,
  unitMonth,
  yearSelected,
}) {
  let municipalityName;
  let municipalityLabel;

  let familiesProvidedLabel;
  let powerLabel;
  let productionLastHourLabel;
  let productionLastMonthLabel;
  let dayProductionLabel;
  let expectedDayProductionLabel;
  let monthProductionLabel;
  let expectedMonthProductionLabel;
  let isIE = /*@cc_on!@*/ false || !!document.documentMode;
  const localeOption = 'nl-BE';

  if (currentData !== undefined) {
    if (!isIE || !isPlaying) {
      municipalityLabel = 'Gemeente';
      productionLastHourLabel = 'Productie afgelopen uur (in ';
      productionLastMonthLabel = 'Productie afgelopen maand (in ';
      dayProductionLabel = 'Productie volledige dag (in ';
      expectedDayProductionLabel = 'Verwachte productie volledige dag (in ';
      monthProductionLabel = 'Productie volledig jaar (in ';
      expectedMonthProductionLabel = 'Verwachte productie volledig jaar (in ';
      familiesProvidedLabel = 'Gezinnen voorzien';
      powerLabel = 'Vermogen (in MW)';
    }
  }
  const currentYear = parseInt(d3.timeFormat('%Y')(new Date()));

  const energyUsePerFamily =
    currentMode === 'realtime'
      ? 9.589
      : yearSelected === currentYear
      ? (3500 * data.length) / 12
      : 3500;

  municipalityName = geography.properties.NAAM;

  return (
    <ToolTip
      key={'#municipality_' + municipalityId}
      active={isActive}
      position="top"
      arrow="left"
      parent={'#municipality_' + municipalityId}
      style={tooltipStyle}
    >
      <table style={{ minWidth: '300px' }}>
        <tbody>
          <tr>
            <td className={classes.leftTableColumn}>{municipalityLabel}</td>
            <td className={classes.rightTableColumn}>
              <b>{municipalityName}</b>
            </td>
          </tr>
          <tr>
            <td className={classes.leftTableColumn}>
              {currentMode === 'realtime'
                ? productionLastHourLabel + unitHour + ')'
                : productionLastMonthLabel + unitMonth + ')'}
            </td>
            <td className={classes.rightTableColumn}>
              <b>
                {isNaN(productionLastHour)
                  ? '0'
                  : currentMode === 'realtime'
                  ? currentFilter === 'inhabitants'
                    ? Math.round(productionLastHour * 10).toLocaleString(
                        localeOption
                      )
                    : Math.round(productionLastHour).toLocaleString(
                        localeOption
                      )
                  : currentFilter === 'inhabitants'
                  ? (Math.floor(productionLastHour / 10) / 10).toLocaleString(
                      localeOption
                    )
                  : (Math.floor(productionLastHour / 100) / 10).toLocaleString(
                      localeOption
                    )}
              </b>
            </td>
          </tr>
          <tr>
            <td className={classes.leftTableColumn}>
              {currentMode === 'realtime'
                ? hasForecast
                  ? expectedDayProductionLabel + unitHour + ')'
                  : dayProductionLabel + unitHour + ')'
                : hasForecast
                ? expectedMonthProductionLabel + unitMonth + ')'
                : monthProductionLabel + unitMonth + ')'}
            </td>
            <td className={classes.rightTableColumn}>
              <b>
                {isNaN(dayProduction)
                  ? '0'
                  : currentMode === 'realtime'
                  ? currentFilter === 'inhabitants'
                    ? Math.round(dayProduction * 10).toLocaleString(
                        localeOption
                      )
                    : Math.round(dayProduction).toLocaleString(localeOption)
                  : currentFilter === 'inhabitants'
                  ? (Math.floor(dayProduction / 10) / 10).toLocaleString(
                      localeOption
                    )
                  : (Math.floor(dayProduction / 100) / 10).toLocaleString(
                      localeOption
                    )}
              </b>
            </td>
          </tr>
          <tr>
            <td className={classes.leftTableColumn}>{familiesProvidedLabel}</td>
            <td className={classes.rightTableColumn}>
              <b>
                {isNaN(uncutDayProduction)
                  ? '0'
                  : (Math.round(
                      uncutDayProduction / energyUsePerFamily
                    )*1000).toLocaleString(localeOption)}
              </b>
            </td>
          </tr>
          <tr>
            <td className={classes.leftTableColumn}>{powerLabel}</td>
            <td className={classes.rightTableColumn}>
              <b>
                {isNaN(installedCapacity)
                  ? '0'
                  : (Math.round(10 * installedCapacity) / 10).toLocaleString(
                      localeOption
                    )}
              </b>
            </td>
          </tr>
        </tbody>
      </table>
    </ToolTip>
  );
}

MapTooltip.propTypes = {
  classes: PropTypes.object,
  currentData: PropTypes.object,
  currentFilter: PropTypes.string,
  currentMode: PropTypes.string,
  data: PropTypes.array,
  dayProduction: PropTypes.number,
  geography: PropTypes.object,
  hasForecast: PropTypes.bool,
  installedCapacity: PropTypes.string,
  isActive: PropTypes.bool,
  isPlaying: PropTypes.bool,
  lang: PropTypes.string,
  municipalityId: PropTypes.number,
  productionLastHour: PropTypes.number,
  uncutDayProduction: PropTypes.number,
  unitHour: PropTypes.string,
  unitMonth: PropTypes.string,
  yearSelected: PropTypes.number,
};
